<template>
  <div>
    <ft-navbar></ft-navbar>
    <section>
      <div class="container">
        <div class="row">
          <div class="col-lg-12 text-center">
            <h2 class="section-heading text-uppercase">Rosetten <span class="text-muted">({{filtered.length}}/{{rosetten.length}})</span>
            </h2>
          </div>
        </div>
        <div class="row my-5">
          <b-form inline>
            <b-form-select aria-label="Grössen" class="mb-2 mr-sm-4 mb-sm-1" v-model="size" :options="sizes"/>
            <b-form-select aria-label="Stile" class="mb-2 mr-sm-4 mb-sm-1" v-model="style" :options="styles"/>
            <b-form-select aria-label="Formen" class="mb-2 mr-sm-4 mb-sm-1" v-model="shape" :options="shapes"/>
            <b-form-checkbox class="mb-2 mr-sm-4 mb-sm-1" v-model="inside" value="with" unchecked-value="without">
              Mit Innendurchmesser
            </b-form-checkbox>
            <b-form-input aria-label="Suche" type="text" placeholder="Nummer (z.B. 1002)"
                          v-model="mnumber"></b-form-input>
          </b-form>
        </div>
        <div class="row">
          <grid min="240px" v-if="filtered.length">
            <div class="scard" v-for="rosette in filtered" :key="rosette.model">
              <div v-if="rosette.thumbnail" @click="showDetail(rosette)" class="scard-img-cnt">
                <b-img-lazy :src="rosette.thumbnail" blank-width="200" blank-height="200" blank-color="#212529"
                            :alt="rosTitle(rosette.model)"
                            class="scard-img-top img-fluid"/>
              </div>
              <div class="scard-body">
                <h4 class="scard-title">{{rosTitle(rosette.model)}}</h4>
                <ul class="list-unstyled">
                  <li v-if="rosette.diameter">Durchmesser: {{rosette.diameter}} cm</li>
                  <template v-else>
                    <li>Länge: {{rosette.length}} cm</li>
                    <li>Breite: {{rosette.width}} cm</li>
                  </template>
                  <li v-if="rosette.diameter_inside">Innendurchmesser: {{rosette.diameter_inside}} cm</li>
                  <li>Stil: {{niceStyles(rosette.styles)}}</li>
                  <li v-if="rosette.inside_rosette_1">
                    Innenrosette:
                    <button @click="showLinkedDetail(rosette.inside_rosette_1)" type="button" class="btn btn-link">
                      R{{rosette.inside_rosette_1.model}}
                    </button>
                  </li>
                  <li v-if="rosette.inside_rosette_2">
                    Innenrosette:
                    <button @click="showLinkedDetail(rosette.inside_rosette_2)" type="button" class="btn btn-link">
                      R{{rosette.inside_rosette_2.model}}
                    </button>
                  </li>
                  <li v-if="rosette.inside_rosette_3">
                    Innenrosette:
                    <button @click="showLinkedDetail(rosette.inside_rosette_3)" type="button" class="btn btn-link">
                      R{{rosette.inside_rosette_3.model}}
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </grid>
          <div class="m-auto" v-else>
            <spinner></spinner>
          </div>
        </div>
      </div>
    </section>
    <b-modal ref="detailModalRef" hide-footer centered size="lg">
      <spinner v-if="imgLoading"></spinner>
      <b-img fluid :src="detailImage" @load="imgLoaded"/>
    </b-modal>
    <b-modal ref="linkedDetailModalRef" hide-footer centered size="lg" :title="detailTitle">
      <spinner v-if="imgLoading"></spinner>
      <b-img fluid :src="detailImage" @load="imgLoaded"/>
      <p>
        {{detailText}}
      </p>
    </b-modal>
  </div>
</template>

<script>
import ftNavbar from '@/components/FTNavbar'
import Grid from '@/components/Grid'
import Spinner from '@/components/Spinner'
import axios from 'axios'

function mSize (r) {
  if (r.diameter != null) {
    return r.diameter
  } else {
    return Math.max(r.width, r.length)
  }
}

export default {
  name: 'Rosette',
  components: {ftNavbar, Grid, Spinner},
  data () {
    return {
      rosetten: [],
      size: 0,
      style: 0,
      shape: 0,
      inside: 'without',
      mnumber: null,
      detailImage: null,
      imgLoading: true,
      detailTitle: null,
      detailText: null,
      sizes: [
        {value: 0, text: 'Alle Grössen'},
        {value: 1, text: '0cm - 10cm'},
        {value: 2, text: '10cm - 30cm'},
        {value: 3, text: '30cm - 70cm'},
        {value: 4, text: '70cm - 100cm'},
        {value: 5, text: 'grösser 100cm'}
      ],
      styles: [],
      shapes: [
        {value: 0, text: 'Alle Formen'},
        {value: 1, text: 'Rund'},
        {value: 2, text: 'Oval'}
      ]
    }
  },
  computed: {
    filtered () {
      let filteredRos = this.rosetten

      if (this.mnumber) {
        return filteredRos.filter(m => ('' + m.model).indexOf('' + this.mnumber) === 0)
      }

      if (this.size === 1) {
        filteredRos = filteredRos.filter(r => mSize(r) <= 10)
      } else if (this.size === 2) {
        filteredRos = filteredRos.filter(r => mSize(r) > 10 && mSize(r) <= 30)
      } else if (this.size === 3) {
        filteredRos = filteredRos.filter(r => mSize(r) > 30 && mSize(r) <= 70)
      } else if (this.size === 4) {
        filteredRos = filteredRos.filter(r => mSize(r) > 70 && mSize(r) <= 100)
      } else if (this.size === 5) {
        filteredRos = filteredRos.filter(r => mSize(r) > 100)
      }

      if (this.style > 0) {
        filteredRos = filteredRos.filter(r => r.styles.indexOf(this.style) > -1)
      }

      if (this.shape > 0) {
        if (this.shape === 1) {
          filteredRos = filteredRos.filter(r => r.diameter > 0)
        } else {
          filteredRos = filteredRos.filter(r => r.diameter == null)
        }
      }

      if (this.inside === 'with') {
        filteredRos = filteredRos.filter(r => r.diameter_inside != null)
      }

      return filteredRos
    }
  },

  methods: {
    rosTitle (model) {
      return 'R' + model
    },
    mapStyle (style) {
      return this.styles.filter(s => s.value === style).map(s => s.text)
    },
    niceStyles (styles) {
      const qq = styles.map(style => this.mapStyle(style)).filter(style => style)
      return qq.join(', ')
    },
    showDetail (r) {
      if (this.detailImage !== r.detail) {
        this.detailImage = ''
        this.imgLoading = true
        this.detailImage = r.detail
      }
      this.$refs.detailModalRef.show()
    },
    showLinkedDetail (r) {
      if (this.detailImage !== r.detail) {
        this.detailImage = ''
        this.imgLoading = true
        this.detailImage = r.detail
      }
      this.detailTitle = this.rosTitle(r.model)
      if (r.diameter_inside) {
        this.detailText = `Innendurchmesser: ${r.diameter_inside}cm`
      } else {
        this.detailText = null
      }
      this.$refs.linkedDetailModalRef.show()
    },
    imgLoaded () {
      this.imgLoading = false
    }
  },
  mounted () {
    axios.get(`${this.$api}/rosetten/list/`)
      .then(response => {
        this.rosetten = response.data.models
        this.styles = response.data.styles
      })
      .catch(error => {
        console.log(error)
      })
  }
}
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/Rosette.vue